import { render, staticRenderFns } from "./ordersItem.vue?vue&type=template&id=3151c438"
import script from "./ordersItem.vue?vue&type=script&lang=js"
export * from "./ordersItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports